import { Box } from '../../Box';
import { Typography } from '../../Typography';
import { XMarkIcon } from '../../Icons';
import { useInterstateTheme } from '../../InterstateThemeProvider';
import { idBuilder } from '../../internal';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const headerStyle = {
  display: 'flex',
  padding: '8px 6px 4px 16px',
  gap: '16px',
  justifyContent: 'space-between',
  alignItems: 'center'
};
const closeButtonStyle = {
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: '32px',
  minWidth: '32px',
  maxWidth: '32px',
  height: '32px',
  minHeight: '32px',
  maxHeight: '32px',
  cursor: 'pointer'
};
export const PopoverHeader = props => {
  const {
    header,
    onClickClose,
    id,
    ...rest
  } = props;
  const theme = useInterstateTheme();
  return /*#__PURE__*/_jsx(_Fragment, {
    children: header && /*#__PURE__*/_jsxs(Box, {
      sx: headerStyle,
      id: idBuilder('ids-popover-header', id),
      className: 'ids-popover-header',
      "data-testid": idBuilder('ids-popover-header', rest['data-testid']),
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: 'h5',
        children: header
      }), /*#__PURE__*/_jsx(Box, {
        sx: closeButtonStyle,
        onClick: onClickClose,
        id: idBuilder('ids-popover-close-button', id),
        className: 'ids-popover-close-button',
        "data-testid": idBuilder('ids-popover-close-button', rest['data-testid']),
        children: /*#__PURE__*/_jsx(XMarkIcon, {
          color: theme.tokens.SemColorOnSurfaceSubdued,
          fontSize: '16px'
        })
      })]
    })
  });
};